import { cn } from '@/lib/utils'

// How far along a guided flow is: one short bar per step, filled up to the one you're on.
export function Steps({ n, at }: { n: number; at: number }) {
  return (
    <span aria-hidden="true" className="flex gap-1.5">
      {Array.from({ length: n }, (_, i) => (
        <span
          key={i}
          className={cn('h-1 flex-1 rounded-full transition-colors', i <= at ? 'bg-brand' : 'bg-secondary')}
        />
      ))}
    </span>
  )
}
